module.exports = __webpack_public_path__ + "static/media/ethics.6c3f17b8.jpg";